import { fetchFamily } from '@gn-audio/core/api/product-catalogue/fetch-family';
import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { Component, Input, OnChanges, SimpleChanges } from 'angular-ts-decorators';
import { CustomizerEvents } from '../models/customizer-events';
import { notifySubscribers } from '../utils/notify-subscribers';

import template from './unique-selling-point.component.html';

@Component({
  selector: 'uniqueSellingPoint',
  template,
})
export class UniqueSellingPointComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = ['$q'];

  @Input() public readonly familyId?: number;
  @Input() public readonly hideOnMobile?: boolean;

  public family?: IFamily;

  constructor(private readonly $q: ng.IQService) { }

  public ngOnChanges(changes: SimpleChanges<UniqueSellingPointComponent>) {
    if (changes.familyId && this.familyId) {
      this.$q
        .when(fetchFamily(this.familyId))
        .then(this.onFamilyLoad.bind(this));
    }
  }

  private onFamilyLoad(family: IFamily) {
    this.family = family;
    notifySubscribers(CustomizerEvents.FamilyLoaded, this.family);
  }
}
